import * as THREE from "three";
import { World } from "./World";
import { vSkyShader, fSkyShader, vDefaultShader, fBasicGammaShader } from '../shaders';

export class BlueBeardWorld extends World {
    constructor({name, model, assets}) {
        super({name, model, assets})
        this.camera.near = .1
        this.camera.far = 100
        this.titleBrightness = .5
        this.titleDisplace = -.25
        this.titleScale = .9
    }

    processModel() {
        super.processModel();

        this.sky = this.model.scene.getObjectByName("sky");
        this.matSky = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: this.sky.material.map },
                time: { value: 0 },
            },
            vertexShader: vSkyShader,
            fragmentShader: fSkyShader,
        });

        this.sky.material = this.matSky;
        
        this.basicGammaMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                gamma: {value: 1.5},
            },
            vertexShader: vDefaultShader,
            fragmentShader: fBasicGammaShader,
            side: THREE.DoubleSide,
        })
        
        this.house = this.model.scene.getObjectByName("house_structure");
        this.basicGammaMat.uniforms.map.value = this.house.material.map
        this.house.material = this.basicGammaMat

        this.environment = this.model.scene.getObjectByName("environment");
        const matEnv = this.basicGammaMat.clone()
        matEnv.uniforms.map.value = this.environment.material.map
        matEnv.uniforms.gamma.value = 1.3
        this.environment.material = matEnv

        this.objects = this.model.scene.getObjectByName("objets_etage");
        const matObjs = this.basicGammaMat.clone()
        matObjs.uniforms.map.value = this.objects.material.map
        matObjs.uniforms.gamma.value = 1.3
        this.objects.material = matObjs

        this.characters = this.model.scene.getObjectByName("personnages");
        const matChars = this.basicGammaMat.clone()
        matChars.uniforms.map.value = this.characters.material.map
        matChars.uniforms.gamma.value = 1.3
        this.characters.material = matChars
    }
}